import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import './FeedItemContainer.pcss';

interface IFeedItemContainerProps {
	collapsed:boolean;
	onClick?:(e:any)=>void;
	extraClassName?:string;
	read:boolean;
	completed:boolean;
	children:any;
	collapsable?:boolean;
}

@observer
export class FeedItemContainer extends React.Component<IFeedItemContainerProps> {
	@observable collapsed:boolean = false;

	constructor(props) {
		super(props);
		this.collapsed = this.props.collapsed;
	}

	toggleCollapsed = () => {
		this.collapsed = !this.collapsed;
	}

	render(){
		return(
			<div onClick={this.props.onClick} className={`feedItemContainer post ${this.props.extraClassName}${this.props.read?'':' unread'}${this.props.completed?' completed':''}${this.collapsed?' collapse':''}`}>
				<div className="dot"></div>
				<table>
					<tbody>
						<tr>
							<td className="icon">{this.props.children[0]}</td>
							<td className="mid">{this.props.children[1]}</td>
							<td className="right">
								{this.props.children[2]}
								<div className={`icon clickable${this.props.collapsable?'':' hidden'}`} onClick={this.toggleCollapsed}>
									{this.collapsed ? <i className="fa fa-chevron-down"></i> : <i className="fa fa-chevron-up"></i>}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}

